var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUkFlagIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1359_71995)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_1359_71995)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
  fill: "#F0F0F0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.13484 7.82361C2.56383 9.86759 1.37922 12.2235 0.689453 14.7827H11.094L4.13484 7.82361Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.3116 14.7828C38.6218 12.2236 37.4371 9.86771 35.8662 7.82373L28.9072 14.7828H39.3116Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.689453 25.2175C1.3793 27.7767 2.56391 30.1326 4.13484 32.1765L11.0938 25.2175H0.689453Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.1768 4.13443C30.1329 2.56342 27.7771 1.37881 25.2178 0.688965V11.0934L32.1768 4.13443Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.82422 35.8655C9.8682 37.4365 12.2241 38.6211 14.7833 39.311V28.9066L7.82422 35.8655Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7832 0.688965C12.224 1.37881 9.86812 2.56342 7.82422 4.13436L14.7832 11.0933V0.688965Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2178 39.311C27.777 38.6211 30.1329 37.4365 32.1768 35.8656L25.2178 28.9066V39.311Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.9072 25.2175L35.8662 32.1766C37.4371 30.1327 38.6218 27.7767 39.3116 25.2175H28.9072Z",
  fill: "#0052B4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.8307 17.3913H22.6088H22.6087V0.169297C21.7548 0.058125 20.8841 0 20 0C19.1157 0 18.2452 0.058125 17.3913 0.169297V17.3912V17.3913H0.169297C0.058125 18.2452 0 19.1159 0 20C0 20.8843 0.058125 21.7548 0.169297 22.6087H17.3912H17.3913V39.8307C18.2452 39.9419 19.1157 40 20 40C20.8841 40 21.7548 39.942 22.6087 39.8307V22.6088V22.6087H39.8307C39.9419 21.7548 40 20.8843 40 20C40 19.1159 39.9419 18.2452 39.8307 17.3913Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2178 25.2175L34.1425 34.1422C34.5529 33.7319 34.9445 33.3029 35.3181 32.8582L27.6773 25.2174H25.2178V25.2175Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7822 25.2175H14.782L5.85742 34.1421C6.26773 34.5526 6.69672 34.9442 7.14141 35.3178L14.7822 27.6768V25.2175Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7829 14.7827V14.7826L5.85824 5.85779C5.44777 6.2681 5.05621 6.69708 4.68262 7.14177L12.3235 14.7826L14.7829 14.7827Z",
  fill: "#D80027"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.2178 14.7828L34.1425 5.85792C33.7322 5.44745 33.3032 5.05589 32.8586 4.68237L25.2178 12.3232V14.7828Z",
  fill: "#D80027"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1359_71995"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_1359_71995"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
})))));
export default SvgUkFlagIcon;